<template>
  <div>
    <van-nav-bar title="策略交易" class="" />
    <van-tabs id="activeTabBar" v-model="activeTab" href="1" style="padding-top: 3px">
      <van-tab to="/create_capital_accounts">
        <template #title>
          <!-- <van-row style="width:100px;">
            <van-col span="12"
              ><img
                style="width: 38px; padding-top: 5px"
                src="../assets/images/home_day1.png"
            /></van-col>
            <van-col span="12" style="padding: 5px; padding-top: 15px"
              >策略</van-col
            >
          </van-row> -->
          <div style="display: inline-flex; align-items: center;">
            <img style="width: 30px; margin: 20px 0px" src="../assets/images/home_icons/home_day.jpeg" alt="" />
            <p style="padding-left: 15px">策略</p>
          </div>
        </template>
      </van-tab>

      <van-tab href="2">
        <template #title>
          <!-- <van-row style="width:100px;">
            <van-col span="12"
              ><img
                style="width: 38px; padding-top: 5px"
                src="../assets/images/home_month1.png"
            /></van-col>
            <van-col span="12" style="padding: 5px; padding-top: 15px"
              >交易</van-col
            >
          </van-row> -->
          <div style="display: inline-flex; align-items: center;">
            <img style="width: 30px; margin: 20px 0px" src="../assets/images/home_icons/home_month.jpeg" alt="" />
            <p style="padding-left: 15px">交易</p>
          </div>
        </template>
        <van-tabs id="activeTabSub">
          <van-tab title="当前策略">
            <van-list
              v-model="loadingCapitalAccount"
              :finished="finishedCapitalAccount"
              finished-text=""
            >
              <van-cell-group>
                <div v-for="(item, index) in currentList" :key="index">
                  <van-cell
                    style="
                      background-color: #ff9900;
                      color: white;
                      padding: 2px 15px 10px;
                    "
                  >
                    <template #title>
                      <p style="margin: 0px">
                        {{ item.name }} ({{ item.order }})
                      </p>
                      <p style="margin: 0px">{{ item.time }}</p>
                    </template>
                    <template #default>
                      <span
                        ><van-button
                          type="danger"
                          size="small"
                          style="
                            border-radius: 10px;
                            margin-top: 14px;
                            height: 26px;
                          "
                          @click="$store.commit('setSelectedCid',item.cid);$router.push({ name: 'Trading', params: {}})"
                          >交易股票</van-button
                        >
                        <router-link to="/account_details"
                          ><van-button
                            type="danger"
                            size="small"
                            style="
                              border-radius: 10px;
                              margin-top: 14px;
                              height: 26px;
                            "
                            @click="goAccountDetails(item.cid)"
                            >账户信息</van-button
                          ></router-link
                        >
                      </span>
                    </template>
                  </van-cell>
                  <van-cell title="当前总资产" style="padding: 5px 16px">
                    <template #default>
                      <span style="color: black">{{ item.total }}元</span>
                    </template>
                  </van-cell>
                  <van-cell title="亏损警戒线 (亏损比)" style="padding: 5px 16px">
                    <template #default>
                      <span style="color: #ff2c27">{{ item.warning }}元 ({{ item.warning_line_ratio }})</span>
                    </template>
                  </van-cell>
                  <van-cell title="亏损平仓线（亏损比）" style="padding: 5px 16px">
                    <template #default>
                      <span style="color: #008000">{{ item.close }}元 ({{ item.close_line_ratio }})</span>
                    </template>
                  </van-cell>
                  <van-cell title="风险保证金" style="padding: 5px 16px">
                    <template #default>
                      <span style="color: black">{{ item.bond }}元</span>
                    </template>
                  </van-cell>
                  <van-cell title="浮动盈亏" style="padding: 5px 16px">
                    <template #default>
                      <span v-if="item.profit_loss < 0" style="color: #008000"
                        >{{ item.profit_loss }}元 ({{ item.proportion }}%)</span
                      >
                      <span v-else style="color: #ff2c27"
                        >{{ item.profit_loss }}元 ({{ item.proportion }}%)</span
                      >
                    </template>
                  </van-cell>
                  <van-cell title="可用余额" style="padding: 5px 16px">
                    <template #default>
                      <span style="color: #ff2c27">{{ item.use }}元</span>
                    </template>
                  </van-cell>
                </div>
              </van-cell-group>
            </van-list>
          </van-tab>
          <van-tab title="历史策略">
            <van-cell-group>
              <router-link to="/closed_capital_info">
                <div
                  v-for="(item, index) in list"
                  :key="index"
                  @click="goDetails(item.cid)"
                >
                  <van-cell>
                    <van-row>
                      <van-col span="24">
                        <span style="font-size: 15px; color: black"
                          >{{ item.name }}({{ item.order }})</span
                        >
                      </van-col>
                    </van-row>
                    <van-row style="line-height: 21px;">
                      <van-col span="20">
                        <van-row>
                          <van-col span="24">
                            <span style="font-size: 13px; color: #808080">{{
                              item.time
                            }}</span>
                          </van-col>
                        </van-row>
                        <van-row>
                          <van-col span="12">
                            <span style="font-size: 13px; color: #808080"
                              >总策略资金:{{ item.total }}</span
                            >
                          </van-col>
                          <van-col span="12">
                            <span style="font-size: 13px; color: #808080"
                              >风险保证金:{{ item.bond }}</span
                            >
                          </van-col>
                        </van-row>
                        <van-row>
                          <van-col span="24">
                            <span style="font-size: 15px; color: black"
                              >累计盈亏:</span
                            ><span v-bind:class="[item.profit >= 0 ? 'redText' : 'greenText']" style="font-size: 15px; padding-left: 10px;">{{
                              item.profit
                            }}</span>
                          </van-col>
                        </van-row>
                      </van-col>
                      <van-col span="4">
                        <van-row>
                          <van-col span="24" style="text-align: right">
                            <img
                              style="height: 50px; width: 50px"
                              src="../assets/images/over.png"
                            />
                          </van-col>
                        </van-row>
                      </van-col>
                    </van-row>
                  </van-cell>
                </div>
              </router-link>
            </van-cell-group>
          </van-tab>
        </van-tabs>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "CapitalAccount",
  mounted: function () {
    this.getHistoryData();
    this.getNowData();
    this.isActiveTab();
    this.activeTab = this.tabs.findIndex(
      (tab) => tab === this.$route.query.activeTab
    );
  },
  data() {
    return {
      activeTab: "0",
      tabs: ["1", "2"],
      list: [],
      currentList: [],
      loadingCapitalAccount: false,
      finishedCapitalAccount: false,
    };
  },
  methods: {
    isActiveTab() {
      let that = this;
      if (!that.$route.query.activeTab) {
        that.activeTab = "2";
      } else {
        that.activeTab = that.$route.query.activeTab;
      }
    },
    getHistoryData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "history_operate",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.list = res.data.data;
            // if (that.list.length == 0) {
            //   that.$toast({
            //     message: "暂无记录",
            //     type: "warning",
            //   });
            // }
          } else if (res.data.code == 0) {
            tthat.$toast.fail(res.data.msg);
          }
        });
    },
    getNowData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "current_operate",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.currentList = res.data.data;
            that.loadingCapitalAccount = false;
            that.finishedCapitalAccount = true;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          } else if (res.data.code == -1) {
            that.$logout(res.data.msg);
          }
        })
        .catch(()=>{
          that.loadingCapitalAccount = false;
          that.finishedCapitalAccount = true;
        });
    },
    //去详情
    goDetails(cid) {
      window.sessionStorage.setItem("cid", cid);
      this.$router.push({
        path: "/closed_capital_info",
      });
    },
    goAccountDetails(cid) {
      window.sessionStorage.setItem("cid", cid);
      this.$router.push({
        path: "/account_details",
      });
    },
  },
};
</script>
<style>
#activeTabBar .van-tab--active {
  border: 1px solid #ee0d25 !important;
}

#activeTabBar .van-tabs__line {
  display: none;
}

#activeTabSub .van-tab--active {
  border: none !important;
  border-bottom: 1px solid #ee0d25 !important;
}
</style>
<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}
.redText {
  color: #ff2c27;
}
.greenText {
  color: #008000;
}
</style>



// WEBPACK FOOTER //
// src/components/CapitalAccount.vue